export default __webpack_public_path__ + "static/media/cropped-Univers_puce_Blanc_270x270.ac8c5d20.png";